kimal.$searchPanel = $('#search-panel');

$('#search-trigger').on('click', function() {
  kimal.$searchPanel.fadeIn();

  if($(window).width()<=1024) {
    kimal.$pageElems.css({
      'overflow': 'hidden',
      'position': 'fixed',
      'top': 0,
      'left': 0,
      'right': 0,
      'bottom': 0
    });
  }
});

$('#search-panel-form__input').on('keyup', function() {
  kimal.$searchPanel.css({
    'overflow-y': 'scroll'
  });

  if($(window).width()>1024) {
    kimal.$body.css({
      'overflow': 'hidden',
      'position': 'fixed',
      'top': '0px',
      'left': '0px',
      'right': '0px',
      'bottom': '0px'
    });
  }
});

$('#close-icon').on('click', function() {
  kimal.$searchPanel.fadeOut();

  kimal.$searchPanel.css({
    'overflow': 'hidden'
  });

  kimal.$pageElems.css({
    'overflow': 'auto',
    'position': 'static'
  });
});
